import classNames from "classnames";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import CustomSelect from "shared/components/common/customSelect";
import { QuestionnaireStep8VS } from "shared/utils/validation";
import ShowMoreText from "react-show-more-text";
import styles from "./style.module.scss";
import { GetQuestionStatement } from "shared/utils/helper";

interface formikValuesInterface {
  jobs: QuestionnaireStep8Type[];
}

interface QuestionnaireStep8Props {
  formikRef: any;
  formData: any;
}

const QuestionnaireStep8 = ({
  formikRef,
  formData,
}: QuestionnaireStep8Props) => {
  const initialValues: formikValuesInterface = {
    jobs: [
      {
        jobTitle: "",
        manualEffort: {},
        definition: "",
        output: "",
      },
    ],
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: QuestionnaireStep8VS,
    onSubmit: () => {},
  });

  const { values, touched, errors } = formik;

  useEffect(() => {
    formikRef.current = formik;
    // eslint-disable-next-line
  }, [formik]);

  useEffect(() => {
    let jobs = formData;
    let fields: any = [];
    for (let k = 0; k < jobs?.length; k++) {
      let obj = {
        jobTitle: jobs?.[k]?.jobTitle,
        manualEffort: jobs?.[k]?.q7?.manualEffort,
        definition: jobs?.[k]?.q7?.definition ? jobs?.[k]?.q7?.definition : "",
        output: jobs?.[k]?.q7?.output,
      };
      fields.push(obj);
    }
    formik.setFieldValue("jobs", fields);
    // eslint-disable-next-line
  }, [formData]);

  return (
    <div className={classNames(styles.stepContainer)}>
      <div className={classNames(styles.head)}>
        <p>Manual Effort</p>
        <h1>
          <span>Q7.</span> {GetQuestionStatement(7)}
        </h1>
      </div>
      <div className={classNames(styles.tableWrapper)}>
        <table className="table" style={{ minWidth: "800px", margin: "0px" }}>
          <thead>
            <tr style={{ height: "44px" }}>
              <th className={classNames(styles.tableHead)}>Job Title</th>
              <th className={classNames(styles.tableHead)}>
                Manual Effort <span>*</span>
              </th>
              <th className={classNames(styles.tableHead)}>Definition</th>
              <th className={classNames(styles.tableHead)}>RAS Output</th>
            </tr>
          </thead>
          <tbody>
            {values.jobs.map((job, index) => {
              return (
                <RowItem
                  job={job}
                  index={index}
                  key={index}
                  formik={formik}
                  formData={formData}
                  touched={touched}
                  errors={errors}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const RowItem = ({ job, touched, index, formik, formData, errors }: any) => {
  const [manualEffortOptions, setManualEffortOptions] = useState<any[]>([]);

  const handleOptions = () => {
    let jobs = formData;
    let dropOptions: any[] = [];

    let options = jobs[index]?.q1?.alldropDowns?.filter(
      (itm: any, inx: number) => itm?.dropdown_id === 7
    )[0]?.option;
    for (let j = 0; j < options?.length; j++) {
      let option = options[j];
      let obj = {
        title: option?.short_des,
        Icon: null,
        action: (index: number) => {
          formik.setFieldValue(
            `jobs[${index}].definition`,
            option?.long_des ? option?.long_des : ""
          );
          formik.setFieldValue(`jobs[${index}].manualEffort`, {
            name: option?.short_des,
            value: option?.id,
            level: option?.level,
            warning: option?.warning,
          });
          formik.setFieldValue(`jobs[${index}].output`, option?.score);
          formik.setFieldTouched(`jobs[${index}].manualEffort`, false);
        },
      };
      dropOptions.push(obj);
    }

    setManualEffortOptions(dropOptions);
  };

  useEffect(() => {
    handleOptions();
    // eslint-disable-next-line
  }, []);

  return (
    <tr>
      <td
        className={classNames(styles.tableContentLabel)}
        style={{ width: "15%", wordBreak: "break-all" }}
      >
        <div className={classNames(styles.titleContainer)}>
          <label>{job.jobTitle}</label>
        </div>
      </td>
      <td
        className={classNames(styles.tableContentLabel)}
        style={{ width: "35%" }}
      >
        <CustomSelect
          placeholder="Select Manual Effort"
          options={manualEffortOptions}
          customInputContainer={classNames(styles.selectionContainer)}
          notRequiredMargin
          customOptionsContainer={classNames(styles.optionsContainer)}
          value={job.manualEffort?.name}
          error={
            touched.jobs?.[index]?.manualEffort &&
            //@ts-ignore
            errors.jobs?.[index]?.manualEffort
          }
          warning={job.manualEffort?.warning ? "Improbable combination" : ""}
          tabIndex={index}
        />
      </td>

      <td
        className={classNames(styles.tableContentLabel)}
        style={{ width: "40%" }}
      >
        <div className={classNames(styles.descContainer)}>
          <ShowMoreText
            lines={3}
            more="Show more"
            less="Show less"
            expanded={false}
            anchorClass="show-more-less-clickable"
            truncatedEndingComponent={"... "}
          >
            <label>{job.definition}</label>
          </ShowMoreText>
        </div>
      </td>
      <td
        className={classNames(styles.tableContentLabel)}
        style={{ width: "10%" }}
      >
        <div className={classNames(styles.scoreContainer)}>
          <label>{job.output ? job.output : 0}</label>
        </div>
      </td>
    </tr>
  );
};

export default QuestionnaireStep8;
